import React, { ReactNode } from "react";
import { AiToastStyle as S } from "./AiToast.style";
import { BaseToast } from "../BaseToast";
import { CustomToastMessage } from "components/ToastProvider/ToastProvider";

export const AiToast: React.FC<CustomToastMessage> = ({ summary, detail, content, isLoadingState }) => {
  return (
    <BaseToast
      icon={<S.Icon isLooping={isLoadingState} />}
      headerText={summary}
      subText={detail}
      content={content as ReactNode}
    />
  );
};
